import React from 'react';
import * as actions from '../../store/actions/index';
import { connect } from 'react-redux';
import './MyStatistics.css';
import './ReactSelectMe.css';
import FontAwesome from 'react-fontawesome';
import StatCard from './StatCard';
import moment from 'moment';
import Loading from '../Loading';
import ReplayHand from '../HandReplayer/ReplayHand.js';
import HandReplayer from '../HandReplayer/HandReplayer.js';
import 'swiper/dist/js/swiper.min.js';
import 'swiper/dist/css/swiper.min.css';
// import Swiper from 'react-id-swiper';
import SingleStat from './SingleStat';
import MediaQuery from 'react-responsive';
import { MyTopHandsWrapper } from 'mygame-components';
import { domain, baseUrl } from "../../common/config.js"
import TournamentHistory from "./TournamentHistory";
import _$ from 'jquery';
import Select from 'react-select-me';
import TournamentHistoryFullScreen from './TournamentHistoryFullScreen';
import TournamentHistoryMobile from './TournamentHistoryMobile';
import { apiService } from '../../common/apiCallService.js'
import OnBoard from '../MygameOnBoard/OnBoard'
import {saveActivity, updateOnBoard } from '../../common/commonService'
import { getColor, getTextColor } from '../../common/ThemeService';
import { DispatcherFunction } from 'mygame-components';
import i18next from 'i18next'
var _ = require('lodash');

class MyStatistics extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: 'My Statistics',
      modalData: {},
      openHandRep: false,
      gameNo: '',
      partitionDate: '',
      playFlag: true,
      lostShowAllHands: false,
      wonShowAllHands: false,
      showMoreSettings: false,
      hideShadow: false,
      tournamentFeed: {},
      loading: true,
      tournamentTypeList: [],
      tournamentSpeedList: [],
      tournamentFeed: [],
      tournamentAggResult: {},
      fullScreenClose: false,
      isOnBoard: localStorage.getItem('mygame_onboarded') === 'N' ? 1 : 0
    }
    this.getTournamentTypeandSpeed()
  }

  async componentDidMount() {
    this.saveSetting(true);
    window.addEventListener('scroll', this.handleScroll, false);
  }
  
  componentWillUnmount = () => {
    window.removeEventListener('scroll', this.handleScroll);
  }
  getTournamentTypeandSpeed = () => {
    this.setState({ loading: true })
    apiService(baseUrl + '/tournamentFeed/getTournamentTypeandSpeed', {
      accountName: localStorage.getItem('accountName')
    }, (data) => {
      this.setState({ tournamentTypeList: data.tournytype, tournamentSpeedList: data.tournySpeed })
      this.setState({ loading: false })
    }, (data) => {
      this.setState({ loading: false })
    })
  }

  getTournamentSpeed = () => {
    apiService(baseUrl + '/tournamentFeed/getTournamentSpeed', {
      accountName: localStorage.getItem('accountName')
    }, (tournamentSpeedList) => {
      this.setState({ tournamentSpeedList })
    }, (data) => {
      this.setState({ loading: false })
    })
  }


  handleScroll = (e) => {
    let newHideShadowValue = _$('html').scrollTop() > 5 ? true : false
    if (this.state.hideShadow !== newHideShadowValue) {
      this.setState({ hideShadow: newHideShadowValue })
    }
  }

  setModalData = (modalData) => {
    this.setState({ modalData });
  }
  
  disableOnBoard = async () => {
    this.setState({ loading: true, isOnBoard: 0 })
    await updateOnBoard()
    this.setState({ loading: false })
  }

  setStarFlagOfHnad = (hand, newStarValue, handListType) => {
    // update local data
    let newMyStatTopHands = this.props.myStatTopHands;
    if(handListType === "won") {
      let newTopWonHands = newMyStatTopHands.topWonHands.map(handObj=>{
        if(hand.gameNo.toString() === handObj.gameNo.toString()) {
          return {...handObj, staredHand: newStarValue}
        } else {
          return handObj;
        }
      })
      newMyStatTopHands.topWonHands = newTopWonHands
    } else {
      let newTopLostHands = newMyStatTopHands.topLostHands.map(handObj=>{
        if(hand.gameNo.toString() === handObj.gameNo.toString()) {
          return {...handObj, staredHand: newStarValue}
        } else {
          return handObj;
        }
      })
      newMyStatTopHands.topLostHands = newTopLostHands
    }
    
    this.props.setMyStatTopHands(newMyStatTopHands);
    this.forceUpdate();

    // api call to set star
    let reqObj = {
        staredHand: newStarValue,
        accountName: localStorage.getItem("accountName"),
        gameType: this.props.myStatSettings.gameType,
        gameNo: hand.gameNo,
        time: hand.time,
        // SB: hand.SB,
        // BB: hand.BB,
        // ringType: hand.ringType,
        // gameSubType: hand.gameSubType,
        // holeCards: hand.holeCards,
    }
    apiService(baseUrl + '/handInfo/setStarFlagOfHandInfo', reqObj, (data) => {
        this.setState({ loading: false });
        saveActivity({
          hit_page: 'MyStatistics',
          hit_type: 'FavouriteHand',
          hit_attribute1: this.props.myStatSettings.gameType,
          hit_attribute2: newStarValue,
          hit_attribute3: hand.gameNo,
          hit_attribute4: hand.time
      })
    }, (error) => {
        console.log("Error", error)
        this.setState({ loading: false })
    })
  }

  onChange = (e) => {
    // e.preventDefault();
    if (e.target.name === "selectedGameType" && (e.target.value === "SitnGo")) {
      alert("Coming Soon...!")
    } else {
      let data = {
        accountName: localStorage.getItem('accountName'),
        gameType: e.target.name === "selectedGameType" ? e.target.value : this.props.myStatSettings.selectedGameType,
        gameSubType: e.target.name === "selectedGameSubType" ? e.target.value : this.props.myStatSettings.selectedGameSubType,
        hitType: e.target.name === "selectedHitType" ? e.target.value : this.props.myStatSettings.selectedHitType,
      }
      if ((e.target.name === "selectedGameType" && this.props.myStatSettings.selectedGameType !== data.gameType)
        || (e.target.name === "selectedGameSubType" && this.props.myStatSettings.selectedGameSubType !== data.gameSubType)
        || (e.target.name === "selectedHitType" && this.props.myStatSettings.selectedHitType !== data.hitType)) {
        if (e.target.name === "selectedGameType") {
          this.props.getPlayerGameSubTypes({ accountName: data.accountName, gameType: data.gameType })
        }
        if (e.target.name === "selectedGameSubType" || e.target.name === "selectedGameType") {
          this.props.getPlayerHitTypes({
            accountName: data.accountName,
            gameType: data.gameType,
            gameSubType: data.gameSubType
          })
        }
        this.props.getPlayerLevels(data)
        this.props.setMyStatSettings({
          [e.target.name]: e.target.value,
        })
      } else {
        if (e.target.name === "selectedHitLevel") {
          this.props.setMyStatSettings({
            [e.target.name]: e.target.value,
          })
        } else {
          this.props.setMyStatSettings({
            [e.target.name]: e.target.value
          })
        }
      }
      if (e.target.name === "selectedGameType" && data.gameType != this.state.gameType)
        this.props.setTournyFilter(
          {
            feedGameType: e.target.name === "selectedGameType" ? e.target.value : this.props.myStatSettings.selectedGameType,
            buyIn: "All",
            gameSubType: "All",
            trnyType: "All",
            gameSpeed: "All",
            dateRange: "This Year"
          })
    }
  }
  onChangeMoreSettings = (e, name) => {
    e.preventDefault();
    this.props.setMyStatSettings({
      [name]: this.props.myStatSettings[name] === "true" ? "false" : "true"
    })
  }
  resetSetting = (e) => {
    this.props.setMyStatSettings({
      selectedGameType: this.props.myStatSettings.gameType,
      selectedGameSubType: this.props.myStatSettings.gameSubType,
      selectedHitLevel: this.props.myStatSettings.hitLevel,
      selectedHitRange: this.props.myStatSettings.hitRange,
      selectedHitType: this.props.myStatSettings.hitType,
      selectedShowHandsStat: localStorage.getItem("showHandsStat"),
      selectedShowProfitStat: localStorage.getItem("showProfitStat"),
      selectedShowRakeStat: localStorage.getItem("showRakeStat"),
    })
    this.setState({ showMoreSettings: false })
  }
  saveSetting = (isOnLoad) => {
    var initial = {
      gameType: this.props.myStatSettings.gameType,
      gameSubType: this.props.myStatSettings.gameSubType,
      hitLevel: this.props.myStatSettings.hitLevel,
      hitRange: this.props.myStatSettings.hitRange,
      hitType: this.props.myStatSettings.hitType,
    }
    var newData = {
      gameType: this.props.myStatSettings.selectedGameType,
      gameSubType: this.props.myStatSettings.selectedGameSubType,
      hitLevel: this.props.myStatSettings.selectedHitLevel,
      hitRange: this.props.myStatSettings.selectedHitRange,
      hitType: this.props.myStatSettings.selectedHitType,
    }
    if (!isOnLoad) {
      localStorage.setItem("showHandsStat", this.props.myStatSettings.selectedShowHandsStat);
      localStorage.setItem("showProfitStat", this.props.myStatSettings.selectedShowProfitStat);
      localStorage.setItem("showRakeStat", this.props.myStatSettings.selectedShowRakeStat);
    } else {
      this.props.setMyStatSettings({
        selectedShowHandsStat: localStorage.getItem("showHandsStat"),
        selectedShowProfitStat: localStorage.getItem("showProfitStat"),
        selectedShowRakeStat: localStorage.getItem("showRakeStat"),
      })
    }
    this.setState({ showMoreSettings: false })
    if (!(_.isEqual(initial, newData)) || isOnLoad) {
      this.props.setMyStatSettings({ ...newData })
      let defaultReportSettings = {
        accountName: localStorage.getItem('accountName'),
        level: 'All Level',
        shift: "Select",
        hitType: '6-seater',
        hitRange: 'This Year',
        hitLevel: "All Level",
        gameType: "NLH",
        userRole: ["PLAYER"],
        userType: "MyGame",
      }
      if (Object.keys(newData).length > 0) {
        if (newData.hitLevel) defaultReportSettings.hitLevel = newData.hitLevel
        if (newData.hitType) defaultReportSettings.hitType = newData.hitType
        if (newData.gameType) defaultReportSettings.gameType = newData.gameType
        if (newData.gameSubType) defaultReportSettings.gameSubType = newData.gameSubType

        if (newData.hitRange) {
          defaultReportSettings.hitRange = newData.hitRange
          if (newData.hitRange == 'Today') {
            defaultReportSettings.fromDate = moment().startOf('day').format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")
            defaultReportSettings.toDate = moment().endOf('day').format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")
          }
          else {
            defaultReportSettings.rangeChange = true
          }
        }
        // let reportCardSetting = this.props.reportCardSetting.filter(reportFilter => reportFilter.gameType === "cash")[0];
        let settings = {
          // ...reportCardSetting,
          ...defaultReportSettings
        }
        // console.log(">>>>>>settings>>>>>>>:", settings)
        if (newData.hitRange == 'Today') {
          let SB = "All";
          let BB = "All";
          if (settings.hitLevel && settings.hitLevel !== "All Level") {
            [SB, BB] = settings.hitLevel.split("/");
          }
          let gameDateInfo = moment().format('DD/MM/YYYY');
          this.props.getMyStatisticsDetails({
            ...settings,
            key: `${gameDateInfo}:${localStorage.getItem("accountName")}:${settings.gameType}:${settings.hitType}:${SB}:${BB}`
          })
        } else {
          this.props.getMyStatisticsDetails(settings)
        }
      }
    }
  }
  handReplayerOpen = (handReply, lossOrwon) => {
    if (this.state.playFlag) {
      let partitionDate = handReply.partitionDate ? handReply.partitionDate : moment.utc(handReply.time)
        .format("YYYY-MM-DD HH:mm:ss");
      saveActivity({
        hit_page: 'MyStatistics',
        hit_type: 'MyStatisticsGameReplay',
        hit_attribute1: handReply.gameNo,
        hit_attribute2: lossOrwon,
        hit_attribute3: '',
        hit_attribute4: '',
        hit_attribute5: ''
      })
      if(window.messageToNative || (window.external && window.external.NativeDispatch)){
        DispatcherFunction("app:menu=3814&name=MYGAME_REPLAYER",{
          "MYGAME_REPLAYER_URL":'https://' + window.location.hostname +
          `/PopUpHandReplayer/${this.props.myStatSettings.gameType}/${handReply.gameNo}/${localStorage.getItem("accountName")}/${handReply.fullDateTime? handReply.fullDateTime: handReply.time}`,
          "location":"yes",
          "height":"720",
          "width":"1000",
          "scrollbars":"yes",
          "status":"yes"
    })}
        else{
      this.setState({ gameNo: handReply.gameNo, partitionDate: partitionDate, openHandRep: true });
        }
    }
  }
  NumberFormatter = (num) => {
    if (Math.abs(num) > 999 && Math.abs(num) <= 999999) {
      return Math.sign(num) * ((Math.abs(num) / 1000).toFixed(1)) + ' K'
    }
    else if (Math.abs(num) > 999999 && Math.abs(num) <= 999999999) {
      return Math.trunc(Math.sign(num) * ((Math.abs(num) / 1000000).toFixed(1))) + ' M'
    }
    else if (Math.abs(num) > 999999999) {
      return Math.sign(num) * ((Math.abs(num) / 1000000).toFixed(1)) + 'B'
    }
    else {
      return Math.sign(num) * Math.abs(num) > 1 ? Math.trunc(Math.sign(num) * Math.abs(num)) : Math.trunc(Math.sign(num) * Math.abs(num)).toFixed(2);
    }

  }

  setTournyDtls = (tournamentAggResult, tournamentFeed) => {
    this.setState({ tournamentAggResult, tournamentFeed, fullScreenClose: true })
  }
  // optionRenderer = (option,selectedOptions) => {
  //    return <div className="dd__option" data-e2e={option.value} key={option}>{option.label}</div>
  //    }
    optionRenderer(option, selectedOptions) {
       return <div>
           <div className={"dd__option"+(option.value === selectedOptions.value ? "dd__selectedOption" : "" )}
            data-e2e={`${option.label}`}>{option.label}</div>
       </div>
     }

  render() {
    const themeColor = getColor();
    const themeTextColor = getTextColor();
    if (localStorage.getItem("showHandsStat") !== "true" && localStorage.getItem("showHandsStat") !== "false") {
      localStorage.setItem("showHandsStat", "true")
    }
    if (localStorage.getItem("showProfitStat") !== "true" && localStorage.getItem("showProfitStat") !== "false") {
      localStorage.setItem("showProfitStat", "false")
    }
    if (localStorage.getItem("showRakeStat") !== "true" && localStorage.getItem("showRakeStat") !== "false") {
      localStorage.setItem("showRakeStat", "false")
    }
    let stats_summary_data = []
    // if(localStorage.getItem("showHandsStat")==="true"){
    stats_summary_data.push({ name: "Hand Played", value: this.props.myStatHands})
    if (this.props.profit != undefined) {
      stats_summary_data.push({ name: "Profit & Loss", value: this.NumberFormatter(this.props.profit) })
    }
    if (this.props.rake != undefined) {
      stats_summary_data.push({ name: "Rake", value: this.NumberFormatter(this.props.rake) })
    }
    if (this.props.winRate != undefined) {
      stats_summary_data.push({ name: "Win Rate", value: this.props.winRate })
    }
    if (this.props.evAllinAdjusted != undefined) {
      stats_summary_data.push({ name: "Winrate – All-In EV Adjusted", value: this.props.evAllinAdjusted })
    }
    let stats_cashout_summary_data=[]
    if(this.props.mycashoutStatsHands!=undefined && this.props.myStatSettings.gameType === "cash" )
    stats_cashout_summary_data.push({ name: "Cash-out hands Played", value: this.props.mycashoutStatsHands })
    if (this.props.cashoutProfit != undefined  && this.props.mycashoutStatsHands!=0  && this.props.myStatSettings.gameType === "cash" ) {
      stats_cashout_summary_data.push({ name: "Cash-out Amount", value: this.NumberFormatter(this.props.cashoutProfit) })
    }
    // if(localStorage.getItem("showProfitStat")==="true" && this.props.myStatSettings.gameType !== "tournament"){
    //   stats_summary_data.push({ name: "P&L", value: `${this.props.profit !== 0 ? (this.props.profit < 0 ? "-" : "+") : ""}${"$"}${Math.abs(this.props.profit.toFixed(2))}` });
    // }
    // if(localStorage.getItem("showRakeStat")==="true"){
    //   stats_summary_data.push({ name: "RAKE", value: `${this.props.rake !== 0 ? (this.props.rake < 0 ? "-" : "+") : ""}${"$"}${Math.abs(this.props.rake.toFixed(2))}` })
    // }

    let topHands = {
      topWonHands: this.props.myStatTopHands && this.props.myStatTopHands.topWonHands ? this.props.myStatTopHands.topWonHands : [],
      topLostHands: this.props.myStatTopHands && this.props.myStatTopHands.topLostHands ? this.props.myStatTopHands.topLostHands : []
    };
    let statData = this.props.myStatisticData;

    let settingData = {}
    if (this.props.myStatGameType) {
      settingData.myStatGameType = this.props.myStatGameType;
    }

    if (this.props.myStatPlayerGameSubTypes && this.props.myStatPlayerGameSubTypes.length > 0) {
      settingData.myStatGameSubType = ['All'].concat(this.props.myStatPlayerGameSubTypes);
    } else {
      settingData.myStatGameSubType = ['All'];
    }

    if (this.props.myStatPlayerHitTypes && this.props.myStatPlayerHitTypes.length > 0) {
      if (this.props.myStatSettings.selectedGameType === "cash") {
        settingData.myStatHitType = this.props.myStatPlayerHitTypes;
      } else {
        settingData.myStatHitType = ['All'].concat(this.props.myStatPlayerHitTypes);
      }
    } else {
      if (this.props.myStatSettings.selectedGameType === "cash") {
        settingData.myStatHitType = [];
      } else {
        settingData.myStatHitType = ["All"];
      }
    }

    if (this.props.myStatPlayerLevels && this.props.myStatPlayerLevels.length > 0) {
      let hitLevel = ["All Level"].concat(
        this.props.myStatPlayerLevels.map((level) => {
          return `${level.SB}/${level.BB}`
        })
      )
      settingData.hitLevel = hitLevel;
    } else {
      settingData.hitLevel = ["All Level"];
    }
    if (this.props.myStatHitRange) {
      settingData.myStatHitRange = this.props.myStatHitRange;
    }
    // required in case we use swiper
    // const params = {
    //   pagination: {
    //     el: '.swiper-pagination',
    //     type: 'bullets',
    //   },
    //   navigation: {
    //     nextEl: '.swiper-button-next',
    //     prevEl: '.swiper-button-prev'
    //   },
    //   spaceBetween: 10,
    //   breakpoints: {
    //     1240: {
    //       slidesPerView: 4,
    //       slidesPerGroup: 4,
    //       loop: false,
    //     },
    //     // when window width is <= 1080px
    //     1080: {
    //       slidesPerView: 3,
    //       slidesPerGroup: 3,
    //       loop: false,
    //     },
    //     810: {
    //       slidesPerView: 2,
    //       slidesPerGroup: 2,
    //       loop: false,
    //     },
    //     680: {
    //       slidesPerView: 1,
    //       slidesPerGroup: 1,
    //       loop: false,
    //     }
    //   }
    // }
    this.props.setHeaderTitle(this.state.title);

    let fullVersion = 0
    if (navigator.appVersion.indexOf("Mac") >= 0) {
      if (navigator.appVersion.indexOf("Mobile") >= 0) {
        let osVersion = /OS (\d+)_(\d+)_?(\d+)?/.exec(navigator.appVersion);
        fullVersion = parseFloat(osVersion[1] + '.' + osVersion[2] + osVersion[3]);
        if (fullVersion > 12.10) {
          fullVersion = 13
        } else {
          fullVersion = 12
        }
      } else {
        let osVersion = /OS X (\d+)_(\d+)_?(\d+)?/.exec(navigator.appVersion);
        // console.log("osVersion",osVersion)
        if(osVersion){
          fullVersion = parseFloat(osVersion[1] + '.' + osVersion[2]);
          if (fullVersion > 10.13) {
            fullVersion = 13
          } else {
            fullVersion = 12
          }
        } else {
          fullVersion = 12
        }
      }
    } else {
      fullVersion = 13;
    }
    console.log("MYSTSATS......",this.props)
    
    return (
      <div className="container myStat_container">
        {this.props.tournamentHistoryFullScreenFlag ? !this.props.tournamentHistoryFlag
          && <TournamentHistoryFullScreen
            setTournyDtls={this.setTournyDtls}
            tournamentTypeList={this.props.tournytype}
            tournamentSpeedList={this.props.tournySpeed} />
          : !this.props.tournamentHistoryFlag
            ? <div>
              
              {(this.props.loading || this.state.loading) && <Loading />}
              {this.state.isOnBoard ==1 && JSON.parse(localStorage.getItem('userRole')).indexOf('PLAYER') != -1  && <OnBoard  disableOnBoard={this.disableOnBoard}/>}
              
              <div className={`ms_header  ${(stats_summary_data.length <= 3 && stats_cashout_summary_data.length<1) || (stats_summary_data[0].value==0 && stats_cashout_summary_data.length>0 )   ? " ms_header_small_height " :  " ms_header_cash_height " } ${this.state.hideShadow ? " removeBoxShadowOnScroll " : ""}`}>
             
              </div>

              <div className={`container ms_header_content ${(stats_summary_data.length <= 3 && stats_cashout_summary_data.length<1) || (stats_summary_data[0].value==0 && stats_cashout_summary_data.length>0 )? " ms_header_content_small_height " : ""}`}>
                <div className="ms_title_bar">
                  <div className="ms_title">{i18next.t("lable.myStatistics")}</div>
                  <div className="ms_title_bar_info" data-e2e="myStats-heading-filter-values" style={{ textTransform: "capitalize" }}>{this.props.myStatSettings.gameType === "cash" && this.props.myStatSettings.gameSubType != "All" ? this.props.myStatSettings.gameSubType : ""} {this.props.myStatSettings.gameType}, {this.props.myStatSettings.hitLevel}, {i18next.t("lable."+this.props.myStatSettings.hitRange)} &nbsp;  &nbsp;</div>
                  <div>
                    <button
                      data-e2e="myStats-settingsModalButton"
                      className='btn btnHalo ms_reportCardSettingBtn'
                      data-toggle="modal"
                      data-target="#settingModal"
                      style={{
                        height: "31px",
                        width: "31px",
                        backgroundColor: themeColor,
                        borderColor: themeColor,
                        alignSelf: 'stretch',
                        borderRadius: '4px',
                        padding: '0',
                        textAlign: 'center',
                        lineHeight: '20px',
                        marginBottom:'10px'
                      }}>
                      <FontAwesome name="fa fa-filter" style={{ color: themeTextColor, fontSize: '21px' }} />
                    </button>
                  </div>

                </div>
                {this.props.myStatHands==0?<div className="ms_header_stats" data-e2e="myStats-heading-stats-container">
                
                  {stats_summary_data ?
                    stats_summary_data.map((stat_data, index) => {
                      return <div key={index} className={`ms_stat ${(stats_summary_data.length <= 3 && stats_cashout_summary_data.length<1) || (stats_summary_data[0].value==0 && stats_cashout_summary_data.length>0 ) ? " ms_stat_single_line " : ""}`}>
                        {/* <MediaQuery maxWidth={950} > */}
                          <div data-e2e="myStats-heading-stats-name" className="ms_stat_title">{i18next.t("lable."+stat_data.name)}:&nbsp;</div>
                        {/* </MediaQuery> */}
                        {/* <MediaQuery minWidth={951} >
                          <div data-e2e="myStats-heading-stats-name" className="ms_stat_title">{i18next.t("lable.WinrateAllInEVAdjusted") : i18next.t("lable."+stat_data.name)}:&nbsp;</div>
                        </MediaQuery> */}
                        <div data-e2e="myStats-heading-stats-value" className={`ms_stat_value ${ (stats_summary_data.length <= 3 && stats_cashout_summary_data.length<1) || (stats_summary_data[0].value==0 && stats_cashout_summary_data.length>0 )? " ms_stat_value_single_line " : ""}`}>{stat_data.value}</div>
                      </div>
                    })
                    : null}
                </div>:<div><div className="ms_header_stats" data-e2e="myStats-heading-stats-container">
                
                {stats_summary_data ?
                    stats_summary_data.map((stat_data, index) => {
                      return <div key={index} className={`ms_stat ${(stats_summary_data.length <= 3 && stats_cashout_summary_data.length<1) || (stats_summary_data[0].value==0 && stats_cashout_summary_data.length>0 )? " ms_stat_single_line " : ""}`}>
                        {/* <MediaQuery maxWidth={950} > */}
                          <div data-e2e="myStats-heading-stats-name" className="ms_stat_title">{i18next.t("lable."+stat_data.name)}:&nbsp;</div>
                        {/* </MediaQuery> */}
                        {/* <MediaQuery minWidth={951} >
                          <div data-e2e="myStats-heading-stats-name" className="ms_stat_title">{stat_data.name === "EV" ? i18next.t("lable.WinrateAllInEVAdjusted") : i18next.t("lable."+stat_data.name)}:&nbsp;</div>
                        </MediaQuery> */}
                        <div data-e2e="myStats-heading-stats-value" className={`ms_stat_value ${(stats_summary_data.length <= 3 && stats_cashout_summary_data.length<1) || (stats_summary_data[0].value==0 && stats_cashout_summary_data.length>0 )? " ms_stat_value_single_line " : ""}`}>{stat_data.value}</div>
                      </div>
                    })
                    : null}
                    </div>
                    <div className="ms_header_stats" data-e2e="myStats-heading-stats-container">
                    {stats_cashout_summary_data ?
                    stats_cashout_summary_data.map((stat_data, index) => {
                      return <div key={index} className={`ms_stat ${stats_cashout_summary_data.length <= 3 ? " ms_stat_single_line " : ""}`} >
                        <MediaQuery maxWidth={950} >
                          <div data-e2e="myStats-heading-stats-name" className="ms_stat_title">{i18next.t("lable."+stat_data.name)}:&nbsp;</div>
                        </MediaQuery>
                        <MediaQuery minWidth={951} >
                          <div data-e2e="myStats-heading-stats-name" className="ms_stat_title">{ i18next.t("lable."+stat_data.name)}:&nbsp;</div>
                        </MediaQuery>
                        <div data-e2e="myStats-heading-stats-value" className={`ms_stat_value ${stats_cashout_summary_data.length <= 3 ? " ms_stat_value_single_line " : ""}`}>{stat_data.value}</div>
                      </div>
                    })
                    : null}
                    </div>
                </div>}  
              </div>
              

              <MediaQuery maxWidth={950} >
                {this.props.tournytype.length > 0 && this.props.myStatSettings.gameType != 'cash' &&
                  <TournamentHistoryMobile
                    tournamentTypeList={this.props.tournytype}
                    tournamentSpeedList={this.props.tournySpeed}
                    fullScreenClose={this.state.fullScreenClose}
                    tournamentAggResult={this.state.tournamentAggResult}
                    tournamentFeed={this.state.tournamentFeed}
                    tournyDtls={this.props.tournyDtls} />
                }
                <div className={`ms_stat_cards_wrapper ${(stats_summary_data.length <= 3 && stats_cashout_summary_data.length<1) || (stats_summary_data[0].value==0 && stats_cashout_summary_data.length>0 )? " ms_stat_cards_wrapper_for_small_header_height " : ""}`}>
                  {statData && statData.length > 0 ?
                    <div className="ms_main_stat_row">
                      {statData.map((data, index) => {
                        return (
                          <StatCard
                            i18next={i18next}
                            gameType={this.props.myStatSettings.selectedGameType}
                            mobileView={true}
                            key={index} statData={data}
                            showFull={true}
                            setModalData={this.setModalData} />
                        )
                      })}
                    </div>
                    : <div className="ms_main_stat_row ms_min_height_less"> <div>{i18next.t("lable.noStatisticsDataFound")}</div> </div>}
                </div>
              </MediaQuery>

              <MediaQuery minWidth={951} >
                {this.props.myStatSettings.gameType != 'cash' && this.props.tournytype.length > 0 &&
                  <TournamentHistory
                    tournamentTypeList={this.props.tournytype}
                    tournamentSpeedList={this.props.tournySpeed}
                    fullScreenClose={this.state.fullScreenClose}
                    tournamentAggResult={this.state.tournamentAggResult}
                    tournamentFeed={this.state.tournamentFeed}
                    tournyDtls={this.props.tournyDtls} />
                }
                <div className={`ms_stat_cards_wrapper ${(stats_summary_data.length <= 3 && stats_cashout_summary_data.length<1) || (stats_summary_data[0].value==0 && stats_cashout_summary_data.length>0 ) ? " ms_stat_cards_wrapper_for_small_header_height " : ""}`}>
                  {statData && statData.length > 0 ?
                    <div className="ms_main_stat_row">
                      {statData.map((data, index) => {
                        return (
                          <StatCard i18next={i18next} mobileView={false} key={index} statData={data} showFull={true} setModalData={this.setModalData} />
                        )
                      })}
                    </div>
                    : <div className="ms_main_stat_row ms_min_height_less"> <div>{i18next.t("lable.noStatisticsDataFound")}</div> </div>}
                </div>
              </MediaQuery>

              {this.props.myStatHands > 0 && this.props.myStatHands < 100 &&
                <div style={{ color: "#F5A623", fontSize: "13px", transform: "translateY(-20px)", fontFamily: "Open Sans", with: "100%" }}>
                  <b>{i18next.t("lable.warning")}: </b> {i18next.t("lable.statsNotLess100")}.
          </div>
              }

              <div className="ms_bigWinAndLost">
                <div className="ms_bigWinAndLost_heading">{i18next.t("lable.Biggest")} {this.props.myStatSettings.selectedGameType === "spin" ? i18next.t("lable.evAdjustW&l") : i18next.t("lable.handsw&l")}</div>
                {/* <div className='ms_blackLine'></div> */}
              </div>

              <div className="container msTopHands_container">
                <span>
                  <MediaQuery minWidth={1051}>
                    <MyTopHandsWrapper
                    i18next={i18next}
                      desktopView={true}
                      isMyStatistics={true}
                      domain={"//" + domain}
                      currency={this.props.currency}
                      gameType={this.props.myStatSettings.selectedGameType}
                      playerReports={{ topHands }}
                      handReplayerOpen={this.handReplayerOpen}
                      setStarFlagOfHnad={this.setStarFlagOfHnad}
                    />
                  </MediaQuery>
                  <MediaQuery maxWidth={1050}>
                    <MyTopHandsWrapper
                    i18next={i18next}
                      desktopView={false}
                      isMyStatistics={true}
                      domain={"//" + domain}
                      currency={this.props.currency}
                      gameType={this.props.myStatSettings.selectedGameType}
                      playerReports={{ topHands }}
                      handReplayerOpen={this.handReplayerOpen}
                      setStarFlagOfHnad={this.setStarFlagOfHnad}
                    />
                  </MediaQuery>
                </span>
              </div>

              {this.state.openHandRep ? <div style={{
                top: 0,
                left: 0,
                zIndex: 20000,
                width: "100%",
                height: "100%",
                overflow: "auto",
                position: "fixed",
                backgroundColor: '#2c2c34'
              }}>
                {fullVersion && parseFloat(fullVersion) < 13 ? <HandReplayer
                i18next={i18next}
                  replayerScreen={'desktop'}
                  gameTypeForTitle={this.props.myStatSettings.gameType}
                  onClose={() => this.setState({ openHandRep: false })}
                  loginStatus={true}
                  gameNo={this.state.gameNo}
                  accountName={localStorage.getItem('accountName')}
                  // playerDtlsList={this.state.playerDtlsList}
                  // actionDtlsList={this.state.actionDtlsList}
                  // defaultPlayersList={this.state.defaultPlayersList}
                  // defaultActionList={this.state.defaultActionList}
                  partitionDate={this.state.partitionDate}
                // fromDate={repoSetting.fromDate}
                // toDate={repoSetting.toDate}
                // gameType={repoSetting.gameType}
                // rawData={this.state.rawData}
                /> :
                  <ReplayHand
                  // i18next={i18next}
                    replayerScreen={'desktop'}
                    loginStatus={true}
                    gameNo={this.state.gameNo}
                    partitionDate={this.state.partitionDate}
                    accountName={localStorage.getItem('accountName')}
                    // playerAlias={this.props.playerReports.playerName}
                    gameTypeForTitle={this.props.myStatSettings.gameType}
                    // fromDate={ repoSetting.fromDate}
                    // toDate= {repoSetting.toDate}
                    // gameType={repoSetting.gameType} 
                    onClose={() => this.setState({ openHandRep: false })}
                  />}
              </div> : null}
              <div className="modal fade" id="statModal" role="dialog">
                <div className="ms_modal_dialog">
                  <div className="modal-content">
                    <div className="ms_card_container">
                      <div className="ms_card_title">{i18next.t("lable."+this.state.modalData.title)}</div>
                      <div className='ms_blackLine_lite ms_line_margin' style={{ marginTop: "17.5px" }} />
                      {this.state.modalData.fields && this.state.modalData.fields.length > 0 ?
                        this.state.modalData.fields.map((data, index) => {
                          return (
                            <SingleStat i18next={i18next} key={index} data={data} />
                          )
                        })
                        : null
                      }
                      <div style={{ display: "flex" }}>
                        <sapn
                          data-e2e="myStats-statsCard-seeLessButton"
                          data-toggle="modal"
                          data-target="#statModal"
                          className="ms_seeless_btn"
                        ><i className="fa fa-chevron-up"
                          style={{
                            color: themeColor
                          }}
                        /></sapn>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal fade" data-backdrop="static" id="settingModal" role="dialog">
                <div className="ms_modal_dialog ms_setting_modal_dialog">
                  <div className="modal-content ms_modal-content">

                    <div className="ms_setting_container">
                      <div className="ms_setting_title">{i18next.t("lable.settings")}</div>
                      {settingData.myStatGameType ?
                        <div className="ms_select_container">
                          <label className="ms_select_label">{i18next.t("lable.game")}</label>
                          <Select
                            // if we want diffrent css for updated filters
                            // s={{ dd__selectedItem: this.props.myStatSettings.selectedGameType.toLowerCase() === this.props.myStatSettings.gameType.toLowerCase() ? "" : " darkColorForChangedValue " }}
                            data-e2e="myStats-setting-selectedGameType"
                            options={
                              settingData.myStatGameType.map(data => {
                                return { value: data === "Mtts" ? "tournament" : data === "Cash" ? "cash" : data, label: data === "Mtts" ? "MTT's" : data === "spin" ? "Spins" : data }
                              })}
                            value={this.props.myStatSettings.selectedGameType}
                            onChange={(option) => { this.onChange({ target: { name: "selectedGameType", value: option.value } }); }}
                          />
                          <span className="ms_select_arrow">
                            <FontAwesome name="fas fa-angle-down" style={{ verticalAlign: "sub", fontWeight: "bold" }} />
                          </span>
                        </div> : null}
                      {this.props.myStatSettings.selectedGameType !== "spin" && settingData.myStatGameSubType ?
                        <div className="ms_select_container">
                          <label className="ms_select_label">{i18next.t("lable.type")}</label>
                          <Select
                            data-e2e="myStats-setting-selectedGameSubType"
                            options={
                              settingData.myStatGameSubType.map(data => {
                                return { value: data, label: data }
                              })}
                            value={this.props.myStatSettings.selectedGameSubType}
                            onChange={(option) => { this.onChange({ target: { name: "selectedGameSubType", value: option.value } }); }}
                          />
                          <span className="ms_select_arrow">
                            <FontAwesome name="fas fa-angle-down" style={{ verticalAlign: "sub", fontWeight: "bold" }} />
                          </span>
                        </div> : null}
                      {this.props.myStatSettings.selectedGameType !== "spin" && this.props.myStatSettings.selectedGameType !== "tournament" && settingData.myStatHitType ?
                        <div className="ms_select_container">
                          <label className="ms_select_label">{i18next.t("lable.Seats")}</label>
                          <Select
                            data-e2e="myStats-setting-selectedHitType"
                            options={
                              settingData.myStatHitType.map(data => {
                                return { value: data, label: data }
                              })}
                            value={this.props.myStatSettings.selectedHitType}
                            onChange={(option) => { this.onChange({ target: { name: "selectedHitType", value: option.value } }); }}
                          />
                          <span className="ms_select_arrow">
                            <FontAwesome name="fas fa-angle-down" style={{ verticalAlign: "sub", fontWeight: "bold" }} />
                          </span>
                        </div> : null}
                      {this.props.myStatSettings.selectedGameType !== "tournament" && settingData.hitLevel ?
                        <div className="ms_select_container">
                          <label className="ms_select_label">{i18next.t("lable.level")}</label>
                          <Select
                            // listPosition={"top"}
                            data-e2e="myStats-setting-selectedHitLevel"
                            options={
                              settingData.hitLevel.map(data => {
                                return { value: data, label: data }
                              })}
                            value={this.props.myStatSettings.selectedHitLevel}
                            onChange={(option) => { this.onChange({ target: { name: "selectedHitLevel", value: option.value } }); }}
                          />
                          <span className="ms_select_arrow">
                            <FontAwesome name="fas fa-angle-down" style={{ verticalAlign: "sub", fontWeight: "bold" }} />
                          </span>
                        </div> : null}
                      {settingData.myStatHitRange ?
                        <div className="ms_select_container" data-e2e="timePeriod">
                          <label className="ms_select_label" >{i18next.t("lable.timePeriod")}</label>
                          <Select className="myStats-setting-selectedHitRange"
                            // s={{ dd__selectedItem: this.props.myStatSettings.selectedHitRange.toLowerCase() === this.props.myStatSettings.hitRange.toLowerCase() ? "" : " darkColorForChangedValue " }}
                            data-e2e="myStats-setting-selectedHitRange"
                            options={
                              settingData.myStatHitRange.map(data => {
                                return { value: data, label: i18next.t("lable."+data) }
                              })}
                            value={this.props.myStatSettings.selectedHitRange} optionRenderer={this.optionRenderer}
                            onChange={(option) => { this.onChange({ target: { name: "selectedHitRange", value: option.value } }); }}
                          />
                          <span className="ms_select_arrow">
                            <FontAwesome name="fas fa-angle-down" style={{ verticalAlign: "sub", fontWeight: "bold" }} />
                          </span>
                        </div> : null}
                      {this.state.showMoreSettings ?
                        <div className="ms_moreSettingsContainer">
                          {this.props.myStatSettings.selectedShowHandsStat === "true" ?
                            <div className="ms_moreStatContainer" data-e2e="myStats-moreSettings-selectedShowHandsStat-true" onClick={(e) => { this.onChangeMoreSettings(e, "selectedShowHandsStat") }}>
                              <span className="ms_showColor">
                                <i className="fa fa-check-square-o" aria-hidden="true"></i>
                              </span><span className="ms_moreStatText"> {i18next.t("lable.hands")} </span>
                            </div>
                            : <div className="ms_moreStatContainer" data-e2e="myStats-moreSettings-selectedShowHandsStat-false" onClick={(e) => { this.onChangeMoreSettings(e, "selectedShowHandsStat") }}>
                              <span className="ms_hideColor">
                                <i className="fa fa-square-o" aria-hidden="true"></i>
                              </span><span className="ms_moreStatText"> {i18next.t("lable.hands")} </span>
                            </div>}
                          {this.props.myStatSettings.selectedGameType !== "tournament" ?
                            this.props.myStatSettings.selectedShowProfitStat === "true" ?
                              <div className="ms_moreStatContainer" data-e2e="myStats-moreSettings-selectedShowProfitStat-true" onClick={(e) => { this.onChangeMoreSettings(e, "selectedShowProfitStat") }}>
                                <span className="ms_showColor">
                                  <i className="fa fa-check-square-o"></i>
                                </span><span className="ms_moreStatText"> {i18next.t("lable.profitAndLoss")} </span>
                              </div>
                              : <div className="ms_moreStatContainer" data-e2e="myStats-moreSettings-selectedShowProfitStat-false" onClick={(e) => { this.onChangeMoreSettings(e, "selectedShowProfitStat") }}>
                                <span className="ms_hideColor">
                                  <i className="fa fa-square-o" aria-hidden="true"></i>
                                </span><span className="ms_moreStatText"> {i18next.t("lable.profitAndLoss")} </span>
                              </div> : null}
                          {this.props.myStatSettings.selectedShowRakeStat === "true" ?
                            <div className="ms_moreStatContainer" data-e2e="myStats-moreSettings-selectedShowRakeStat-true" onClick={(e) => { this.onChangeMoreSettings(e, "selectedShowRakeStat") }}>
                              <span className="ms_showColor">
                                <i className="fa fa-check-square-o"></i>
                              </span><span className="ms_moreStatText"> {i18next.t("lable.rake")} </span>
                            </div>
                            : <div className="ms_moreStatContainer" data-e2e="myStats-moreSettings-selectedShowRakeStat-false" onClick={(e) => { this.onChangeMoreSettings(e, "selectedShowRakeStat") }}>
                              <span className="ms_hideColor">
                                <i className="fa fa-square-o" aria-hidden="true"></i>
                              </span><span className="ms_moreStatText"> {i18next.t("lable.rake")} </span>
                            </div>}
                        </div> : null}

                      <div className="ms_settingButton_container">
                        <button
                          data-e2e="myStats-save-setting-button"
                          data-dismiss="modal"
                          onClick={() => this.saveSetting()}
                          className={`mg-btn ms_saveSetting_btn ${this.props.myStatSettings.selectedGameType === "cash" ? "" : " ms_saveSetting_btn_always_bottom "}`}
                          style={{
                            backgroundColor: themeColor,
                          }}
                        ><span className="ms_saveSetting_text" data-e2e="applyButton"
                          style={{
                            color: themeTextColor,
                          }}
                        >{i18next.t("lable.apply")}</span></button>
                        {/* this button is required */}
                        {/* <button
                    data-e2e="myStats-moreSetting-toggle-button"
                    onClick={()=>this.setState({showMoreSettings: !this.state.showMoreSettings})}
                    className='mg-btn ms_showMoreSetting_btn'
                  ><span className="ms_showMoreSetting_text">{this.state.showMoreSettings? "Less ": "More "}Settings</span></button> */}
                      </div>

                    </div>
                    <span className="ms_setting_closeButton"
                      data-e2e="myStats-settings-close-button"
                      onClick={() => this.resetSetting()}
                      data-dismiss="modal"
                    >
                      <FontAwesome name="fas fa-times" />
                    </span>

                  </div>
                </div>
              </div>
            </div>
            : <TournamentHistoryDetails
              tournamentAggResult={this.state.tournamentAggResult}
              tournamentFeed={this.state.tournamentFeed[0]}
            />}
      </div>
    )
  }
}


const mapStateToProps = state => {
  return {
    loading: state.commonReducer.loading,
    reportCardSetting: state.multipleReportCards.reportCardSetting,
    myStatPlayerLevels: state.multipleReportCards.myStatPlayerLevels,
    myStatisticData: state.multipleReportCards.myStatisticData,
    myStatTopHands: state.multipleReportCards.myStatTopHands,
    rake: state.multipleReportCards.rake,
    profit: state.multipleReportCards.profit,
    myStatHands: state.multipleReportCards.myStatHands,
    winRate: state.multipleReportCards.winRate,
    evAllinAdjusted: state.multipleReportCards.evAllinAdjusted,
    myStatPlayerGameSubTypes: state.multipleReportCards.myStatPlayerGameSubTypes,
    myStatPlayerHitTypes: state.multipleReportCards.myStatPlayerHitTypes,
    myStatHitRange: state.multipleReportCards.myStatHitRange,
    myStatSettings: state.multipleReportCards.myStatSettings,
    myStatHitType: state.multipleReportCards.myStatHitType,
    myStatGameType: state.multipleReportCards.myStatGameType,
    tournamentHistoryFlag: state.multipleReportCards.tournamentHistoryFlag,
    tournamentHistoryFullScreenFlag: state.multipleReportCards.tournamentHistoryFullScreenFlag,
    tournyDtls: state.multipleReportCards.tournyDtls,
    tournytype: state.multipleReportCards.tournytype,
    tournySpeed: state.multipleReportCards.tournySpeed,
    currency:state.multipleReportCards.currency,
    activeTournyFilter: state.multipleReportCards.activeTournyFilter,
    lang: state.header.lang,
    mycashoutStatsHands: state.multipleReportCards.mycashoutStatsHands,
    cashoutProfit: state.multipleReportCards.cashoutProfit,

  };
};

const mapDispatchToProps = dispatch => {
  return {
    setHeaderTitle: (newTitle) => dispatch(actions.setHeaderTitle(newTitle)),
    getMyStatisticsDetails: (settings) => dispatch(actions.getMyStatisticsDetails(settings)),
    setMyStatTopHands: (data) => dispatch(actions.setMyStatTopHands(data)),
    setMyStatSettings: (settings) => dispatch(actions.setMyStatSettings(settings)),
    getPlayerLevels: (data) => dispatch(actions.getPlayerLevels(data)),
    getPlayerGameSubTypes: (data) => dispatch(actions.getPlayerGameSubTypes(data)),
    getPlayerHitTypes: (data) => dispatch(actions.getPlayerHitTypes(data)),
    setTournyFilter: (data) => dispatch(actions.setTournyFilter(data))

  }
};

export default connect(mapStateToProps, mapDispatchToProps)(MyStatistics);


/** WEBPACK FOOTER **
 ** ./src/components/MyStatistics/MyStatistics.js
 **/